import React from "react";
import { Total } from "../../../../Components/Total";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { Card } from "./Components/Card";
import { CardSkeleton } from "./Components/CardSkeleton";
import { CheckCargosResult } from "../../../../../../../domain/usecases/check-cargos";
import DrawerAppBar from "../../../../../../components/mobile/Navbar";
import { checkShipmentActions } from "../../store";
import { useDispatch } from "react-redux";

type Props = {};

export const Report: React.FC<Props> = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const dispatch = useDispatch();

  const checkResult = location.state.checkResult as CheckCargosResult;
  const items = checkResult?.error?.data.items;

  return (
    <>
      <DrawerAppBar
        title="Relatório"
        onBack={() => {
          navigate(-1);
        }}
      />
      <Total
        text="Total de Produtos"
        number={items ? `${items?.length}` : "0"}
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <>
          {items ? (
            <>
              {items.map((item: any, index: number) => {
                const success = item.amount === 0;
                return (
                  <Card
                    key={index}
                    title={success ? "Suceso" : "Quantidade Incorreta"}
                    content={
                      success
                        ? `O produto de código ${item.code} está correto`
                        : `O produto de código ${item.code} está incorreto`
                    }
                    success={success}
                  />
                );
              })}
              <Button
                variant="contained"
                color="secondary"
                sx={{ color: "white", height: "50px", fontWeight: "bold" }}
                onClick={() => {
                  dispatch(checkShipmentActions.setCheckList({ list: [] }));
                  navigate("/mobile/check");
                }}
              >
                Sair
              </Button>
            </>
          ) : (
            <>
              <CardSkeleton />
              <CardSkeleton />
              <CardSkeleton />
            </>
          )}
        </>
      </Stack>
    </>
  );
};
